// Hauteur de ton Header pour décaler le contenu vers le bas
export const HEADER_XS = 56;
export const HEADER_SM = 64;
export const HEADER_HEIGHT = { xs: `${HEADER_XS}px`, sm: `${HEADER_SM}px` };